import React, { Component } from 'react';
import { 
  BrowserRouter as Router, Route, Link, Switch
} from 'react-router-dom';
import App  from './App';
import Confirmation from './Confirmation';

export default class Navigation extends Component {
  render() {
    return (
      <Router>
        <Switch>
          <Route exact path="/" component={App}/>
          <Route exact path="/confirm" component={Confirmation}/>
          <Route path="*" component={App}/>
        </Switch>
      </Router>
    );
  }
}


// WEBPACK FOOTER //
// ./src/Router.js